import React, { useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import Store from "logic/local-storage/Store";
import { StatusIcon } from "components/common";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./Routes";
import { toGenericS3InputCreateRequest } from "./formDataAdapter";
import FormWrap from "../common/FormWrap";
const Container = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.variant.darkest.default};
    margin: 25px 0;
    padding: 15px;
    border-radius: 4px;
    width: max-content;
  `
);
const Subheader = styled.h3`
  margin: 0 0 10px;
`;
const ReviewItems = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0 0 25px 10px;
    padding: 0;

    li {
      padding: 5px;

      :nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    }

    strong {
      ::after {
        content: ':';
        margin-right: 5px;
      }
    }
  `
);
const StepReview = ({ onSubmit, externalInputSubmit = void 0 }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { formData } = useContext(FormDataContext);
  const throttleEnabled = !!((_a = formData.genericS3ThrottleEnabled) == null ? void 0 : _a.value);
  const [saveInput, setSaveInput] = useFetch(
    null,
    (result) => {
      if (result == null ? void 0 : result.id) {
        Store.sessionSet("setup_wizard_input_id", result.id);
      }
      onSubmit();
    },
    "POST",
    toGenericS3InputCreateRequest(formData),
    urlWithEventHubParams
  );
  const formError = saveInput.error ? {
    full_message: saveInput.error,
    nice_message: /* @__PURE__ */ React.createElement("span", null, "We were unable to save your Input, please try again in a few moments.")
  } : null;
  useEffect(() => {
    if (saveInput.error) {
      setSaveInput(null);
    }
  }, [saveInput.error, setSaveInput]);
  const handleSubmit = () => {
    if (externalInputSubmit) {
      onSubmit(formData);
      return;
    }
    setSaveInput(ApiRoutes.INTEGRATIONS.GenericS3.SAVE_INPUT);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Save and Start Input",
      loading: saveInput.loading,
      error: formError,
      description: "Check out everything below to make sure it's correct, then click the button below to complete your S3 setup!"
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Subheader, null, "Input Configuration"), /* @__PURE__ */ React.createElement(ReviewItems, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Name: "), /* @__PURE__ */ React.createElement("span", null, (_b = formData.genericS3Name) == null ? void 0 : _b.value)), ((_c = formData.awsAccessKey) == null ? void 0 : _c.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS Access Key ID: "), /* @__PURE__ */ React.createElement("span", null, (_d = formData.awsAccessKey) == null ? void 0 : _d.value)), ((_e = formData.assumeRoleArn) == null ? void 0 : _e.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS Assume Role (ARN): "), /* @__PURE__ */ React.createElement("span", null, (_f = formData.assumeRoleArn) == null ? void 0 : _f.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS SQS Queue name: "), /* @__PURE__ */ React.createElement("span", null, (_g = formData.sqsQueueName) == null ? void 0 : _g.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS S3 Region: "), /* @__PURE__ */ React.createElement("span", null, (_h = formData.awsS3Region) == null ? void 0 : _h.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Polling Interval: "), /* @__PURE__ */ React.createElement("span", null, (_i = formData.pollingInterval) == null ? void 0 : _i.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Content Format Type: "), /* @__PURE__ */ React.createElement("span", null, (_j = formData.contentTypes) == null ? void 0 : _j.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Compression Type: "), /* @__PURE__ */ React.createElement("span", null, (_k = formData.compressionType) == null ? void 0 : _k.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "SQS Message Batch Size: "), /* @__PURE__ */ React.createElement("span", null, (_l = formData.sqsMessageBatchSize) == null ? void 0 : _l.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Enable Throttling: "), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: throttleEnabled })))))
  );
};
export default StepReview;
